import Layers from "slotworks/graphics/layers/layers";
import BetModel from "slotworks/model/bets/bet-model";
import { Services } from "slotworks/services/services";
import AbstractTextControl from "slotworks/smart-ui/controls/abstract/abstract-text-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class TotalStakeTextControl extends AbstractTextControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.text.setAutoResize(true);
    }

    public updateOptions(options: ControlOptions) {
        const totalStake = options.getTotalStake();

        //Removed 'free text from UI in freeBet' from operator request

        // if (BetModel.freeBet) {
        //     this.text.setText(Services.translations.get("free"));
        // } else {
        //     this.text.setText(Services.currency.format(totalStake, null, false));
        // }

        this.text.setText(Services.currency.format(totalStake, null, false));
    }
}
